<template>
  <div style="height: 100%">
    <funcionalidade-header
      :custom-voltar="true"
      :titulo="tituloNavegacao"
      @click="voltar"
    />

    <div id="func-customizada" class="func-customizada"/>

    <FuncionalidadeCustomizadaTermoDeUso
      v-if="termoDeUsoOpened && idTermoDeUso"
      :id-termo="idTermoDeUso"
      :titulo="tituloTermoDeUso"
      @aceito="aceitoTermoDeUso"
      @cancelar="voltarTermoDeUso"
      @voltar="voltarTermoDeUso"
      @close="openTermoDeUso"
    />

    <div v-if="linkExterno.show">
      <el-row>
        <el-col :span="24">
          <PesquisaMensagem
            :descricao="linkExterno.descricao"
            :height="'220'"
            :titulo="linkExterno.titulo"
            :width="'220'"
            icone="img_helper_success"
          />
        </el-col>
        <el-col :span="24" class="text-center">
          <el-link
            :href="linkExterno.url"
            :underline="false"
            class="el-button el-button--primary"
            target="_blank"
            @click="$router.go(-1)"
          >
            Acessar
          </el-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import mshubPayload from '@/utils/mshubPayload'
import PesquisaMensagem from '@/components/Pesquisa/PesquisaMensagem.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { encodeEmbedData } from '@/utils/utils'
import FuncionalidadeCustomizadaTermoDeUso from '@/components/FuncionalidadeCustomizada/FuncionalidadeCustomizadaTermoDeUso'
import { ChatResource } from '@/API'

export default {
  name: 'FuncionalidadeCustomizadaWebViewComponent',
  data () {
    return {
      loaded: false,
      linkExterno: {
        show: false,
        url: null,
        titulo: 'Você está deixando o ambiente corporativo!',
        descricao: 'Clique no botão para ser redirecionado.'
      },
      termoDeUsoOpened: false,
      url: null
    }
  },
  components: {
    PesquisaMensagem,
    FuncionalidadeHeader,
    FuncionalidadeCustomizadaTermoDeUso
  },
  computed: {
    ...mapState('SetupApp', ['apiChavePasse', 'apiOcorrenciaPublico', 'bundle', 'aplicacao', 'funcionalidade', 'config', 'embedJson']),
    ...mapGetters('Login', ['chavePasse', 'nomeUsuario', 'chaveUnica']),
    ...mapGetters('SetupApp', ['aplicacao', 'funcParams']),
    tituloNavegacao () {
      return this.funcionalidade.nome
    },
    isWebView () {
      return this.funcParams.AberturaWebviewWeb
    },
    idTermoDeUso () {
      if (this.funcionalidade.parametros && this.funcionalidade.parametros.idTermoDeUso) {
        return this.funcionalidade.parametros.idTermoDeUso
      }
      return null
    },
    tituloTermoDeUso () {
      return this.funcParams.textos.tituloTermoDeUso
    }
  },
  methods: {
    ...mapActions('Login', ['setChavePasse']),
    verificaChavePasse: async function (ocorrenciaData) {
      const chavePasseData = await this.carregarChavePasse()

      if (!chavePasseData && !chavePasseData.aplicacao) {
        this.setChavePasse(null)
        this.$router.go(-1)
        return
      }

      // Verifica se a funcionalidade que está sendo executada é a mesma funcionalidade da chavePasse
      if (chavePasseData.aplicacao.idFuncionalidade !== this.funcionalidade.idFuncionalidade) {
        return this.gerarChavePasse({
          id_ocorrencia: ocorrenciaData.id_ocorrencia,
          protocolo: ocorrenciaData.protocolo
        })
      } else {
        // Valida a data de expiração da Chave passe
        const dateNow = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
        const dataExpiracao = moment(chavePasseData.dataExpiracao).format('YYYY-MM-DD HH:mm:ss')

        if (dateNow > dataExpiracao) {
          this.$router.go(-1)
          return
        }

        return this.atualizarChavePasse(ocorrenciaData)
      }
    },
    async init () {
      const ocorrenciaData = await this.gerarOcorrencia()

      if (!ocorrenciaData) {
        this.$router.go(-1)
        return
      }

      if (!this.chavePasse) {
        await this.gerarChavePasse({
          id_ocorrencia: ocorrenciaData.id_ocorrencia,
          protocolo: ocorrenciaData.protocolo
        })
      } else {
        await this.verificaChavePasse(ocorrenciaData)
      }

      this.url = `${this.aplicacao.rotas.funcionalidadeCustomizadaRedirect.rota}?instanciaApp=${this.bundle}&chavePasse=${this.chavePasse}`

      if (!this.isWebView || this.isWebView === 1) {
        this.loaded = true

        if (!this.isSolicitacao) {
          if (this.idTermoDeUso) {
            this.termoDeUsoOpened = true
          } else {
            this.loaded = true
            window.omnichannelSDK.embed({
              id: 'func-customizada',
              url: this.url,
              urlExterna: true,
              json: {
                maxHeight: 'auto'
              }
            })
          }
        }
      } else if (this.isWebView === 2) {
        this.loaded = true
        this.linkExterno = {
          titulo: this.linkExterno.titulo,
          descricao: this.linkExterno.descricao,
          show: true,
          url: this.url
        }
      }
    },
    async gerarOcorrencia () {
      const result = await this.apiOcorrenciaPublico.gerarOcorrencia({
        loading: true,
        headers: {
          bundle: this.bundle,
          id_funcionalidade: this.funcionalidade.idFuncionalidade
        },
        payload: {
          solicitante: this.nomeUsuario,
          identificador_solicitante: this.chaveUnica,
          id_cliente: this.aplicacao.idOperadora,
          id_tipo_ocorrencia: this.funcParams.idTipoOcorrencia,
          modo: 1,
          nova: 0
        },
        notifyFailure: true,
        handlerErrorIgnore: false
      })

      return result.data
    },
    async gerarChavePasse (ocorrencia) {
      const payload = {
        idFuncionalidade: this.funcionalidade.idFuncionalidade,
        origem: 'web',
        idTipoOcorrencia: this.funcParams.idTipoOcorrencia,
        dadosOcorrencia: ocorrencia
      }
      if (
        this.embedJson &&
        Object.prototype.hasOwnProperty.call(this.embedJson, 'atendimento') &&
        Object.prototype.hasOwnProperty.call(this.embedJson.atendimento, 'tokenAtendente') &&
        this.embedJson.atendimento.tokenAtendente
      ) {
        const tokenAtendente = this.embedJson.atendimento.tokenAtendente
        const atendente = await ChatResource.getAtendente(tokenAtendente)
        payload.atendente = {
          id: atendente.atendenteRefId,
          nome: atendente.nome,
          email: atendente.email,
          perfilAtendimento: {
            id: atendente.perfil.perfilAtendimentoRefId,
            nome: atendente.perfil.nome,
            descricao: atendente.perfil.descricao
          },
          isGestor: atendente.perfil.isGestor
        }
      }
      const result = await this.apiChavePasse.criarChavePasse({
        loading: true,
        payload: mshubPayload(payload),
        notifyFailure: true,
        handlerErrorIgnore: false
      })

      if (!result.data) {
        this.$router.go(-1)
        return
      }

      await this.setChavePasse(result.data)

      return result.data
    },
    async carregarChavePasse () {
      const result = await this.apiChavePasse.carregarDadosChavePasse({
        loading: true,
        query: {
          'instanciaApp': encodeEmbedData(this.bundle),
          'chavePasse': this.chavePasse,
          'chaveFuncionalidade': this.funcionalidade.idFuncionalidade
        },
        notifyFailure: true,
        handlerErrorIgnore: false
      })

      return result.data
    },
    async atualizarChavePasse (ocorrencia) {
      const result = await this.apiChavePasse.atualizarChavePasse({
        loading: true,
        payload: mshubPayload({
          'chavePasse': this.chavePasse,
          'origem': 'web',
          'idFuncionalidade': this.funcionalidade.idFuncionalidade,
          'dadosOcorrencia': ocorrencia
        }),
        notifyFailure: true,
        handlerErrorIgnore: false
      })

      return result.data
    },
    openTermoDeUso () {
      this.termoDeUsoOpened = false
    },
    aceitoTermoDeUso () {
      this.loaded = true
      window.omnichannelSDK.embed({
        id: 'func-customizada',
        url: this.url,
        urlExterna: true,
        json: {
          maxHeight: 'auto'
        }
      })
      this.termoDeUsoOpened = false
    },
    voltarTermoDeUso () {
      this.$router.go(-1)
    },
    voltar () {
      window.parent.postMessage({
        uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
        origin: 'omnichannel',
        client: this.config.id || 'func-handler',
        type: 'command',
        command: 'VOLTAR_DASHBOARD',
        data: {},
        timestamp: new Date().getTime()
      }, '*')
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.func-customizada > iframe {
  max-height: calc(100vh - 80px);
}
</style>
<style scoped>
.main {
  padding: 20px;
}

.el-link {
  text-transform: uppercase;
  line-height: 17px;
  font-size: 12px;
  font-weight: 700;
  padding: 12px;
  width: 200px;
  color: #FFFFFF;
}
</style>
